var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("wa-force-update-on-mounted", [
    _c(
      "header",
      {
        class: _vm.componentClass,
        style: _vm.componentStyle,
        attrs: { id: "header" },
      },
      [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "div",
              {
                staticClass:
                  "wrap-app-header position-relative display-flex flex-items-center flex-content-between size-lg tablet:size-md",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "app-header-menu-toggle display-flex flex-items-center tablet:display-none",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "flat swap-icons",
                        attrs: {
                          "aria-label": _vm.mainMenuLabel,
                          "data-balloon-pos": "right",
                        },
                        on: { click: _vm.toggleMainMenu },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "initial-icon",
                          attrs: {
                            icon: _vm.isShowingMainMenu
                              ? _vm.$v7.regular.faXmark
                              : _vm.$v7.regular.faBars,
                            size: "xl",
                          },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "hover-icon",
                          attrs: {
                            icon: _vm.$v7.regular.faHamburger,
                            size: "xl",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.mainMenuLabel)),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "app-header-links display-flex flex-items-center tablet:flex-items-stretch flex-content-center tablet:flex-content-start",
                  },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "wrapper-logo-flag-animated button flat",
                        attrs: { to: { name: "home" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "main_navigation_link_click",
                              { destination: "home" }
                            )
                          },
                        },
                      },
                      [
                        _c("wa-logo-flag", {
                          attrs: { "logo-color": _vm.logoColor || undefined },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Font Awesome"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "display-none tablet:display-block tablet:margin-left-3xl",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "wrap-links display-flex flex-items-center",
                            staticStyle: { gap: "var(--spacing-md)" },
                          },
                          [
                            _vm.$account
                              ? _c(
                                  "site-link",
                                  {
                                    class: _vm.mainLink(_vm.routes.kits),
                                    attrs: { to: _vm.routes.kits.location },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.$posthog.capture(
                                          "main_navigation_link_click",
                                          { destination: "kits" }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "display-none laptop:display-inline",
                                      },
                                      [_vm._v("Your ")]
                                    ),
                                    _vm._v("Kits\n              "),
                                  ]
                                )
                              : _c(
                                  "site-link",
                                  {
                                    class: _vm.mainLink(_vm.routes.start),
                                    attrs: { to: _vm.routes.start.location },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.$posthog.capture(
                                          "main_navigation_link_click",
                                          { destination: "start" }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Start\n              "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.search),
                                attrs: {
                                  to: _vm.routes.search.location,
                                  title: "Search icons",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "icon_search" }
                                    )
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: _vm.$v7.solid.faMagnifyingGlass,
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "sr-only" }, [
                                  _vm._v("Search Icons"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.icons),
                                attrs: { to: _vm.routes.icons.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "icons" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Icons\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.docs),
                                attrs: { to: _vm.routes.docs.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "docs" }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n                Docs\n              ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.plans),
                                attrs: { to: _vm.routes.plans.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "plans" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Plans\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.mainLink(_vm.routes.support),
                                attrs: { to: _vm.routes.support.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "support" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Support\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline padding-y-xs padding-x-md margin-right-md",
                                attrs: {
                                  href: "https://podcastawesome.com",
                                  target: "_blank",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      { destination: "podcast" }
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Podcast\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "app-header-account display-flex flex-items-center tablet:margin-left-2xl",
                  },
                  [
                    _vm.$account
                      ? _c(
                          "site-link",
                          {
                            class: [
                              "button flat",
                              { active: _vm.routes.account.active },
                            ],
                            attrs: {
                              to: _vm.routes.account.location,
                              "aria-label": "Your Account",
                              "data-balloon-pos": "left",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.$posthog.capture(
                                  "main_navigation_link_click",
                                  { destination: "account" }
                                )
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v7.regular.faCircleUser,
                                size: "xl",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Your Account"),
                            ]),
                          ],
                          1
                        )
                      : _c(
                          "site-link",
                          {
                            class: [
                              "button flat swap-icons",
                              { active: _vm.routes.signIn.active },
                            ],
                            attrs: {
                              to: _vm.routes.signIn.location,
                              "aria-label": "Sign In",
                              "data-balloon-pos": "left",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.$posthog.capture(
                                  "main_navigation_link_click",
                                  { destination: "sign_in" }
                                )
                              },
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "initial-icon",
                              attrs: {
                                icon: _vm.$v7.regular.faRightToBracket,
                                size: "xl",
                              },
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "hover-icon",
                              attrs: {
                                icon: _vm.$v7.regular.faPersonToPortal,
                                size: "xl",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Sign In"),
                            ]),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "transition",
              {
                attrs: {
                  name: "toggle-app-header-menu",
                  "enter-active-class":
                    "animate__animated animate__faster animate__fadeIn",
                  "leave-active-class":
                    "animate__animated animate__faster animate__fadeOut",
                  appear: "",
                },
              },
              [
                _vm.isShowingMainMenu
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "app-header-menu with-border-bottom tablet:display-none",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "wrap-links padding-x-md",
                            staticStyle: {
                              "--hr-border-color": "var(--fa-lt-gravy)",
                            },
                          },
                          [
                            _vm.$account
                              ? _c(
                                  "site-link",
                                  {
                                    class: _vm.menuLink(_vm.routes.kits),
                                    attrs: { to: _vm.routes.kits.location },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.$posthog.capture(
                                          "main_navigation_link_click",
                                          {
                                            destination: "kits",
                                            context: "responsive_menu",
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Your Kits\n            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "site-link",
                                  {
                                    class: _vm.menuLink(_vm.routes.start),
                                    attrs: { to: _vm.routes.start.location },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.$posthog.capture(
                                          "main_navigation_link_click",
                                          {
                                            destination: "start",
                                            context: "responsive_menu",
                                          }
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Start\n            "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.menuLink(_vm.routes.search),
                                attrs: { to: _vm.routes.search.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      {
                                        destination: "icon_search",
                                        context: "responsive_menu",
                                      }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Search\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.menuLink(_vm.routes.icons),
                                attrs: { to: _vm.routes.icons.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      {
                                        destination: "icons",
                                        context: "responsive_menu",
                                      }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Icons\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.menuLink(_vm.routes.docs),
                                attrs: { to: _vm.routes.docs.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      {
                                        destination: "docs",
                                        context: "responsive_menu",
                                      }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Docs\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.menuLink(_vm.routes.plans),
                                attrs: { to: _vm.routes.plans.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      {
                                        destination: "plans",
                                        context: "responsive_menu",
                                      }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Plans\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "site-link",
                              {
                                class: _vm.menuLink(_vm.routes.support),
                                attrs: { to: _vm.routes.support.location },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      {
                                        destination: "support",
                                        context: "responsive_menu",
                                      }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Support\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "display-block no-underline padding-y-sm padding-x-md",
                                attrs: {
                                  href: "https://podcastawesome.com",
                                  target: "_blank",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$posthog.capture(
                                      "main_navigation_link_click",
                                      {
                                        destination: "podcast",
                                        context: "responsive_menu",
                                      }
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n              Podcast\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }